function isJustWatchTVPlayBtnLanguageSupported(language: string): boolean {
	return ['en', 'bg', 'cs', 'fi', 'de', 'hu', 'ko', 'pl', 'pt', 'sv', 'tr', 'fr', 'it'].includes(language);
}

export { isJustWatchTVPlayBtnLanguageSupported };
